import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { capitalizeFirstCharOnly } from "_helpers";
import Avatar from "components/v2/common/Avatar";

export default function DMHeaderDetails({ sourceName, author }) {
  const messageLock = useSelector((state) => state.inbox.messageLock);
  const viewerName = messageLock?.lockedByName || "Another admin"
  const heldByAnotherAdmin = messageLock?.heldByAnotherAdmin;

  return (
    <Box sx={styles.wrapper}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Box>
          <Avatar
            src={undefined}
            userName={author}
            alt={author}
            background={"teal"}
            initialsCount={2}
            style={styles.avatar}
          />
        </Box>
        <Box>
          <Box as="p" sx={styles.userName}>
            {author}
          </Box>
          <Box as="p" sx={styles.metaDetails}>
            Direct Message · {capitalizeFirstCharOnly(sourceName)}
          </Box>
        </Box>
      </Box>

      {heldByAnotherAdmin && (
        <Box>
          <Box sx={styles.viewingBadge}>
            <Box component="span" sx={styles.pulseDot} />
            {viewerName || "Another admin"} is viewing
          </Box>
        </Box>
      )}
    </Box>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    justifyContent: "space-between",
    padding: "15px",
    borderBottom: "1px solid rgb(241, 237, 230)",
  },
  userName: {
    color: "#1a2b20",
    m: 0,
    fontFamily: "FustatBold",
    fontSize: "16px",
  },
  metaDetails: {
    color: "#98a29a",
    m: 0,
    fontFamily: "FustatMedium",
    fontSize: "14px",
  },
  viewingBadge: {
    display: "flex",
    alignItems: "center",
    gap: "7px",
    background: "#f4efe6",
    border: "1px solid #ecdfc9",
    padding: "6px 11px",
    borderRadius: "20px",
    color: "#8a6d3b",
    fontFamily: "FustatBold",
    fontSize: "12px",
  },
  pulseDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    background: "#d99a2b",
    animation: "pulseDot 1.4s infinite",
    "@keyframes pulseDot": {
      "0%, 100%": {
        opacity: 1,
        transform: "scale(1)",
      },
      "50%": {
        opacity: 0.35,
        transform: "scale(0.8)",
      },
    },
  },
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "5px",
    fontSize: "16px",
    textTransform: "capitalize",
    borderRadius: "9999px",
  },
};
